"use client"

import { IntegrationScript } from "../lib/IntegrationScript"

const src = "https://connect.facebook.net/en_US/fbevents.js"

export const MetaPixelTag = () => {
  return (
    <>
      <script
        id="meta_pixel_inline"
        dangerouslySetInnerHTML={{
          __html: `!function(f,n)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[]}(window)`,
        }}
      />

      <IntegrationScript id="meta_pixel" src={src} />
    </>
  )
}
